import styled from '@emotion/styled'

import { Flex } from 'ui-base/flex/Flex'

export const PageContent = styled(Flex)`
  margin: auto;
`
